module.exports = __webpack_public_path__ + "img/Pot2.2a02598f.svg";